import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Button, Table, message, Spin, Card } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import request from "helper/request";
import AdminClientHeader from "modules/admin/clients/components/header/AdminClientHeader";
import { shortId } from "helper/util";
import "./RoutePlanDetailPage.scss";

const RoutePlanDetailPage = () => {
  const { id } = useParams();
  const history = useHistory();
  const [routePlan, setRoutePlan] = useState(null);
  const [loading, setLoading] = useState(false);

  const breadCrumbs = [
    { text: "PLANS", onClick: () => history.push("/admin/plans") },
    { text: `PLAN ${shortId(id)}` }
  ];

  useEffect(() => {
    fetchRoutePlan();
  }, [id]);

  const fetchRoutePlan = async () => {
    setLoading(true);
    try {
      const response = await request.get(`/routeplan/${id}`);
      setRoutePlan(response);
    } catch (error) {
      console.error("Error fetching route plan:", error);
      message.error("Failed to load route plan");
    } finally {
      setLoading(false);
    }
  };

  const formatAddress = (address) => {
    if (!address) return "-";
    const parts = [];
    if (address.recipientName) parts.push(address.recipientName);
    if (address.addressLine1) parts.push(address.addressLine1);
    if (address.addressLine2) parts.push(address.addressLine2);
    if (address.city) parts.push(address.city);
    if (address.state) parts.push(address.state);
    if (address.zipCode) parts.push(address.zipCode);
    return parts.join(", ");
  };

  const columns = [
    {
      title: "Paquete ID",
      dataIndex: "id",
      key: "id",
      width: 120
    },
    {
      title: "Pickup Address",
      key: "pickupAddress",
      render: (_, record) => formatAddress(record.pickupAddress)
    },
    {
      title: "Delivery Address",
      key: "deliveryAddress",
      render: (_, record) => formatAddress(record.deliveryAddress)
    }
  ];

  if (loading) {
    return (
      <div className="routeplan-detail-page">
        <AdminClientHeader breadCrumbs={breadCrumbs} hasButton={false} />
        <div className="content-wrapper" style={{ textAlign: "center", padding: "50px" }}>
          <Spin size="large" />
        </div>
      </div>
    );
  }

  if (!routePlan) {
    return (
      <div className="routeplan-detail-page">
        <AdminClientHeader breadCrumbs={breadCrumbs} hasButton={false} />
        <div className="content-wrapper">
          <p>Route plan not found</p>
        </div>
      </div>
    );
  }

  return (
    <div className="routeplan-detail-page">
      <AdminClientHeader breadCrumbs={breadCrumbs} hasButton={false} />
      <div className="content-wrapper">
        <div className="header-section">
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={() => history.push("/admin/plans")}
            style={{ marginBottom: "16px" }}
          >
            Back to Plans
          </Button>
          <h2 className="page-title">Route Plan: {shortId(id)}</h2>
        </div>

        <Card className="info-card" style={{ marginBottom: "24px" }}>
          <div className="info-grid">
            <div className="info-item">
              <span className="label">Full Plan ID:</span>
              <span className="value">{id}</span>
            </div>
            <div className="info-item">
              <span className="label">Total Paquetes:</span>
              <span className="value">{routePlan.paquetes?.length || 0}</span>
            </div>
            <div className="info-item">
              <span className="label">Created At:</span>
              <span className="value">
                {routePlan.createdAt
                  ? new Date(routePlan.createdAt).toLocaleString()
                  : "-"}
              </span>
            </div>
          </div>
        </Card>

        <h3>Paquetes</h3>
        <Table
          dataSource={routePlan.paquetes || []}
          columns={columns}
          rowKey="id"
          pagination={{
            pageSize: 20,
            showSizeChanger: true,
            showTotal: (total) => `Total ${total} paquetes`
          }}
        />
      </div>
    </div>
  );
};

export default RoutePlanDetailPage;
